import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';
import { BookingTypeSettings } from 'app/models/rtc/booking/constants';
import { WebRTCFeatures } from 'app/services/rtc/constants';
import { Set } from 'immutable';
import { GlobalPlatformSupport } from 'app/services/rtc/PlatformSupport';

/**
 * Return required features for the active booking type
 */
export const useRequiredFeatures = (): Set<WebRTCFeatures> => {
  const bookingState = useBookingState();

  if (bookingState) {
    return BookingTypeSettings[bookingState.bookingType].requiredFeatures;
  } else {
    return Set();
  }
};

/**
 * Return `true` if all features required by current booking type
 * are supported by the browser
 */
export const useIsWebRTCSupported = (): boolean => {
  const requiredFeatures = useRequiredFeatures();
  return GlobalPlatformSupport.hasFeatures(requiredFeatures);
};
